import { SaveOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Divider,
  Drawer,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Tooltip,
} from "antd";
import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import React, { FC, useContext, useState } from "react";
import { IUpdateCompanySettings, useClient } from "../../Context/ClientContext";
import {
  Discount_Policy,
  DuplicateCopy_Type,
  EntitySettings,
  ItemRate_Type,
  RoundOff_Type,
  SettingsSections,
  vouchersSettings,
} from "../../Services/SettingService";
import { notificationContext } from "../../Common/PageRoute";
import AdditionalNotes from "../../Common/AdditionalNotes";
import {
  Voucher_Nature,
  Voucher_Type,
  voucherNatureOptions,
} from "../../Services/VoucherServices";
import TermsAndConditionModal from "../Sales/Terms&ConditionModal";
import { CompanyGSTTypes } from "../../../Types/CommonConstants";

export interface IDropdownProps<T = string | number> {
  value: T;
  label: string;
  key?: string | number | T;
  title?: string;
}

const SettingVoucherTemplate: FC<{
  openDrawer: boolean;
  onCancel: () => void;
  setTrigger: any;
  templateId?: number;
  templateName?: string;
  templateType?: SettingsSections;
  setAddTemplateResponse?: any;
}> = (props) => {
  console.log("Props: ", props);
  const [form] = Form.useForm();
  const { companySettings, updateCompanySettings, currentClient } = useClient();
  const { openNotification } = useContext(notificationContext);
  const [selTemplateType, setSelTemplateType] = useState<SettingsSections>(
    props.templateType || SettingsSections.All
  );
  const [duplicateCopy, setDuplicateCopy] = React.useState<DuplicateCopy_Type>(
    DuplicateCopy_Type.Original
  );
  const [tnCTemplateID, setTnCTemplateID] = React.useState<any>();
  const [disclaimerText, setDisclaimerText] = React.useState<string>("");
  const [tnCText, setTnCText] = React.useState<string>("");
  const [openModel, setOpenModel] = React.useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });
  const [openNotes, setOpenNotes] = React.useState<boolean>(false);
  const [note, setNote] = React.useState<string>();
  const [notesInitial, setNotesInitial] = React.useState<string>();
  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);
  // const [isEdit, setIsEdit] = React.useState<boolean>(false);
  const [editorContent, setEditorContent] = React?.useState("");
  const [fromData, setFromData] = React?.useState<{
    allFiled: EntitySettings | undefined;
    postObjName: string;
    indexEditData: number | undefined;
  }>({ allFiled: undefined, postObjName: "invoiceSettings", indexEditData: 0 });
  // const [addNewVoucherTypeChechbox, setAddNewVoucherTypeChechbox] =
  //   React.useState<boolean>(false);
  const [isSystem, setIsSystem] = React.useState<boolean>(true);
  const [deleteTempleteComformation, setDeleteTempleteComformation] =
    React.useState<boolean>(false);
  const [onCheckBoxTrigger, setOnCheckBoxTrigger] =
    React.useState<boolean>(false);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [selVoucherSettingData, setSelVoucherSettingData] =
    React.useState<vouchersSettings>();
  const [showRCM, setShowRCM] = React.useState<boolean>(false);
  // const handleSelect = (value: any) => {
  //   setIsEdit(false);
  // };
  // const handleChange = (content: any) => {
  //   setEditorContent(content);
  // };

  React?.useEffect(() => {
    const vTempOptions = companySettings?.setting?.vouchersSettings?.map<
      IDropdownProps<SettingsSections>
    >((vch: vouchersSettings) => ({
      key: vch.id,
      value: vch.settingType,
      label: vch.title,
    }));
    const selVTemp =
      props.templateId || props.templateName
        ? companySettings?.setting?.vouchersSettings?.find(
            (x) =>
              (x?.title === props.templateName || x?.id === props.templateId) &&
              x?.settingType === selTemplateType
          )
        : companySettings?.setting?.vouchersSettings?.find(
            (x) => x?.settingType === SettingsSections.Invoice
          );
    setSelVoucherSettingData(selVTemp);
    let selSettings;
    switch (selTemplateType) {
      case SettingsSections.Invoice:
        selSettings = selVTemp?.settings?.invoiceSettings;
        setDuplicateCopy(
          selVTemp?.settings?.invoiceSettings?.invoiceCopyLabelling
            ?.duplicateCopyType
        );
        setDisclaimerText(selVTemp?.settings?.invoiceSettings?.disclaimer);
        setTnCText(selVTemp?.settings?.invoiceSettings?.termsnConditions);
        break;
      case SettingsSections.CrNote:
      case SettingsSections.DrNote:
        selSettings = selVTemp?.settings?.returnNoteSettings;
        setDisclaimerText(selVTemp?.settings?.returnNoteSettings?.disclaimer);
        setTnCText(selVTemp?.settings?.returnNoteSettings?.termsnConditions);
        break;
      case SettingsSections.PurInvoice:
        selSettings = selVTemp?.settings?.billSettings;
        setDisclaimerText(selVTemp?.settings?.billSettings?.disclaimer);
        setTnCText(selVTemp?.settings?.billSettings?.termsnConditions);
        break;
      case SettingsSections.Expenses:
      case SettingsSections.Income:
        selSettings = selVTemp?.settings?.expenseSettings;
        break;
      case SettingsSections.SOrder:
      case SettingsSections.POrder:
      case SettingsSections.Quotation:
      case SettingsSections.PInvoice:
        selSettings = selVTemp?.settings?.orderSettings;
        setDisclaimerText(selVTemp?.settings?.orderSettings?.disclaimer);
        setTnCText(selVTemp?.settings?.orderSettings?.termsnConditions);
        break;
      default:
        selSettings = selVTemp?.settings?.basicSettings;
        break;
    }
    setShowRCM(selSettings?.showRCM);
    form.setFieldsValue({
      ...selSettings,
      title: props.templateName ? selVTemp?.title : "",
      voucherType:
        selTemplateType === SettingsSections.All ? undefined : selTemplateType,
      // voucherType: vTempOptions?.find(
      //   (vTemp) =>
      //     vTemp.key === props.templateId || vTemp.key === props.templateName
      // ),
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, selTemplateType]);

  const highlightLabel = (label: string) => {
    if (!searchQuery) return label;
    const regex = new RegExp(`(${searchQuery})`, "gi");
    const parts = label.split(regex);

    return (
      <span>
        {parts.map((part, index) => {
          // Highlight the matching part
          if (part.toLowerCase() === searchQuery.toLowerCase()) {
            return (
              <span
                key={index}
                style={{
                  color: "white",
                  backgroundColor: "rgb(106 119 227)",
                }}
              >
                {part}
              </span>
            );
          }
          return <span key={index}>{part}</span>;
        })}
      </span>
    );
  };

  const shouldShowField = (label: string) =>
    label.toLowerCase().includes(searchQuery.toLowerCase());

  return (
    <>
      <Drawer
        maskClosable={false}
        closable={false}
        title={`${
          props.templateId || props.templateName ? "Update" : "Add"
        } voucher template`}
        open={props.openDrawer}
        // onClose={() => props.onCancel()}
        width="50vw"
        extra={
          <Space
            style={{
              marginRight: 20,
            }}
          >
            <Button
              onClick={() => {
                props.onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              loading={saveButtonLoading}
              onClick={() => {
                form.validateFields().then((val: any) => {
                  debugger;
                  setSaveButtonLoading(true);
                  const currentPostData = {
                    ...val,
                    tnCTemplateId: tnCTemplateID?.templateId,
                  };
                  let maxVoucherTemplateNo =
                    companySettings!.setting?.vouchersSettings?.reduce(
                      (acc: number, rec: any) =>
                        (acc = rec.id > acc ? rec.id : 0),
                      0
                    ) + 1;
                  let newVal = {
                    id: props.templateId
                      ? props.templateId
                      : maxVoucherTemplateNo,
                    title: val.title,
                    settingType: selTemplateType,
                    settings: {
                      basicSettings:
                        selTemplateType === SettingsSections.Journal ||
                        selTemplateType === SettingsSections.Contra ||
                        selTemplateType === SettingsSections.Payment ||
                        selTemplateType === SettingsSections.Receipt ||
                        selTemplateType === SettingsSections.Asset
                          ? currentPostData
                          : null,
                      invoiceSettings:
                        selTemplateType === SettingsSections.Invoice
                          ? currentPostData
                          : null,
                      orderSettings:
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.POrder ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.PInvoice
                          ? currentPostData
                          : null,
                      returnNoteSettings:
                        selTemplateType === SettingsSections.CrNote ||
                        selTemplateType === SettingsSections.DrNote
                          ? currentPostData
                          : null,
                      billSettings:
                        selTemplateType === SettingsSections.PurInvoice
                          ? currentPostData
                          : null,
                      expenseSettings:
                        selTemplateType === SettingsSections.Expenses ||
                        selTemplateType === SettingsSections.Income
                          ? currentPostData
                          : null,
                    },
                    system: props.templateName
                      ? selVoucherSettingData?.system
                      : false,
                  };

                  if (!props.templateId && !props.templateName) {
                    updateCompanySettings!(
                      selTemplateType,
                      {
                        ...companySettings,
                        setting: {
                          ...companySettings?.setting!,
                          vouchersSettings: [
                            ...companySettings?.setting?.vouchersSettings!,
                            newVal,
                          ],
                        },
                      },
                      newVal,
                      IUpdateCompanySettings.addNew
                    ).then((result: any) => {
                      if (result?.status) {
                        setSaveButtonLoading(false);
                        props.setTrigger((prev: boolean) => !prev);
                        openNotification(
                          "success",
                          "Setting added successfully."
                        );
                      } else {
                        setSaveButtonLoading(false);
                        openNotification(
                          "error",
                          result.message ?? "There is some error."
                        );
                      }
                      props.onCancel();
                    });
                  } else {
                    const newValpostData = {
                      vouchersSettings: [newVal],
                    };

                    const allCustomization =
                      companySettings?.setting?.vouchersSettings;
                    let selIndex = allCustomization?.findIndex(
                      (set: vouchersSettings) => set.id === props.templateId
                    );
                    allCustomization?.splice(selIndex!, 1, newVal)!;
                    updateCompanySettings!(
                      props.templateType!,
                      {
                        ...companySettings,
                        setting: {
                          ...companySettings?.setting!,
                          vouchersSettings: allCustomization!,
                        },
                      },
                      newValpostData,
                      // props.templateName,
                      IUpdateCompanySettings.onlyUpdate,
                      props.templateId
                    ).then((result: any) => {
                      if (result?.status) {
                        setSaveButtonLoading(false);
                        setSelVoucherSettingData(undefined);
                        props.setTrigger((prev: boolean) => !prev);
                        openNotification(
                          "success",
                          "Setting updated successfully."
                        );
                      } else {
                        setSaveButtonLoading(false);
                        openNotification(
                          "error",
                          result?.message ?? "There is some error."
                        );
                      }
                      props.onCancel();
                    });
                  }
                });
              }}
            >
              {props.templateId || props.templateName ? "Update" : "Save"}
            </Button>
          </Space>
        }
      >
        <div
          style={{
            padding: "5px 5px 5px 5px",
            maxHeight: "100%",
            overflowY: "auto",
          }}
        >
          {/* <Row justify="space-between">
            <Col lg={10} sm={24}>
              <Row gutter={5}>
                <Col
                  xl={8}
                  lg={9}
                  sm={9}
                  xs={9}
                  // style={{ alignContent: "center" }}
                >
                  <span>Voucher Template</span>
                </Col>
                <Col xl={10} lg={10} sm={10} xs={10}>
                  <Select
                    style={{ width: "100%" }}
                    disabled={addNewVoucherTypeChechbox}
                    labelInValue
                    showSearch
                    placeholder="Select..."
                    optionFilterProp="children"
                    filterOption={filterOption}
                    defaultValue={{
                      value: SettingsSections.Invoice,
                      label: "TAX INVOICE",
                    }}
                    value={{
                      value: select.label,
                      label: select.label,
                      title: select.value,
                    }}
                    options={companySettings?.setting?.vouchersSettings?.map(
                      (x: any, index: number) => ({
                        value: x?.title,
                        label: x?.title,
                        title: `${x?.settingType}`,
                        key: index,
                      })
                    )}
                    onChange={(e: any) => {
                      const findCurrentData =
                        companySettings?.setting?.vouchersSettings?.find(
                          (x) => x.title === e.value
                        );
                      setIsSystem(findCurrentData?.system!);
                      setSelect({
                        value: Number(e.title),
                        label: e.label,
                        key: e.key,
                      });
                      setPreviousSelect({
                        value: Number(e.title),
                        label: e.label,
                        key: e.key,
                      });
                      handleSelect(e);
                    }}
                  />
                </Col>
                {!addNewVoucherTypeChechbox && !isSystem && (
                  <Col xl={6} lg={5} sm={5} xs={5}>
                    <Button onClick={() => setDeleteTempleteComformation(true)}>
                      Delete
                    </Button>
                  </Col>
                )}
              </Row>
            </Col>

            <Col lg={14} sm={24}>
              <Row gutter={5} justify="end">
                <Col xl={7} lg={7} sm={7}>
                  <Checkbox
                    disabled={false}
                    className="custom-select"
                    checked={addNewVoucherTypeChechbox}
                    style={{ marginTop: "6px" }}
                    onClick={(e: any) => {
                      setOnCheckBoxTrigger(e.target.checked);
                      setAddNewVoucherTypeChechbox(e.target?.checked);
                      setIsEdit(e.target?.checked);
                      if (e.target.checked) {
                        setSelect({
                          value: SettingsSections.Invoice,
                          label: "",
                          key: "",
                        });
                      } else {
                        setSelect({
                          value: previousSelect.value,
                          label: previousSelect.label,
                          key: previousSelect.key,
                        });
                      }
                    }}
                  >
                    <span>Create New Template</span>
                  </Checkbox>
                </Col>

                {addNewVoucherTypeChechbox && (
                  <>
                    <Col xl={5} lg={7} sm={7}>
                      <Select
                        style={{ width: "100%" }}
                        labelInValue
                        showSearch
                        placeholder="Select..."
                        optionFilterProp="children"
                        filterOption={filterOption}
                        value={select.value}
                        defaultValue={SettingsSections.Invoice}
                        options={[
                          {
                            key: SettingsSections.Invoice,
                            value: SettingsSections.Invoice,
                            label: "Sales Invoice",
                          },
                          {
                            key: SettingsSections.Quotation,
                            value: SettingsSections.Quotation,
                            label: "Estimate",
                          },
                          {
                            key: SettingsSections.SOrder,
                            value: SettingsSections.SOrder,
                            label: "Sales Order",
                          },
                          {
                            key: SettingsSections.PurInvoice,
                            value: SettingsSections.PurInvoice,
                            label: "Purchase Invoice",
                          },
                          {
                            key: SettingsSections.POrder,
                            value: SettingsSections.POrder,
                            label: "Purchase Order",
                          },
                          {
                            key: SettingsSections.PInvoice,
                            value: SettingsSections.PInvoice,
                            label: "Proforma Invoice",
                          },
                        ]}
                        onChange={(e: any) => {
                          setSelect({
                            ...select,
                            value: e.value,
                            label: "",
                            key: "",
                          });
                        }}
                      />
                    </Col>
                  </>
                )}
                {addNewVoucherTypeChechbox && (
                  <>
                    <Col xl={5} lg={7} sm={6}>
                      <Form.Item
                        name=""
                        className="m-0"
                        rules={[
                          {
                            required: true,
                            message: "Enter a template name",
                          },
                        ]}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input
                          placeholder="Template Name"
                          onChange={(e: any) => {
                            setSelect({
                              ...select,
                              postNewName: e.target?.value,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
                <Col xl={4} lg={4} sm={4}>
                  {isEdit ? (
                    <Space>
                      <Button
                        type="primary"
                        icon={<SaveOutlined />}
                        loading={saveButtonLoading}
                        onClick={() => {
                          if (isEdit && select.value) {
                            if (
                              addNewVoucherTypeChechbox
                                ? select.postNewName &&
                                  !companySettings?.setting?.vouchersSettings?.find(
                                    (x) => x.title === select.postNewName
                                  )
                                : true
                            ) {
                              form.validateFields().then((val: any) => {
                                setSaveButtonLoading(true);
                                const currentPostData = {
                                  ...val,
                                  tnCTemplateId: tnCTemplateID?.templateId,
                                };

                                let newVal = {
                                  title: addNewVoucherTypeChechbox
                                    ? select.postNewName!
                                    : select.label,
                                  settingType: select.value,
                                  settings: {
                                    [fromData?.postObjName]: currentPostData,
                                  },
                                  system: addNewVoucherTypeChechbox
                                    ? false
                                    : isSystem,
                                };

                                if (addNewVoucherTypeChechbox) {
                                  updateCompanySettings!(
                                    select.value!,
                                    {
                                      ...companySettings,
                                      setting: {
                                        ...companySettings?.setting!,
                                        vouchersSettings: [
                                          ...companySettings?.setting
                                            ?.vouchersSettings!,
                                          newVal,
                                        ],
                                      },
                                    },
                                    newVal,
                                    select.postNewName,
                                    IUpdateCompanySettings.addNew
                                  ).then((result: any) => {
                                    if (result?.status) {
                                      setIsEdit(false);
                                      setAddNewVoucherTypeChechbox(false);
                                      setSaveButtonLoading(false);
                                      openNotification(
                                        "success",
                                        "Setting added successfully."
                                      );
                                      setSelect({
                                        value: select.value!,
                                        label: select.postNewName!,
                                        key: "",
                                      });
                                    } else {
                                      setSaveButtonLoading(false);
                                      openNotification(
                                        "error",
                                        result.message ?? "There is some error."
                                      );
                                    }
                                  });
                                } else {
                                  const newValpostData = {
                                    vouchersSettings: [newVal],
                                  };

                                  const allCustomization =
                                    companySettings?.setting?.vouchersSettings;

                                  allCustomization?.splice(
                                    fromData.indexEditData!,
                                    1,
                                    newVal
                                  )!;

                                  updateCompanySettings!(
                                    select.value!,
                                    {
                                      ...companySettings,
                                      setting: {
                                        ...companySettings?.setting!,
                                        vouchersSettings: allCustomization!,
                                      },
                                    },
                                    newValpostData,
                                    select.label
                                  ).then((result: any) => {
                                    if (result?.status) {
                                      setIsEdit(false);
                                      setAddNewVoucherTypeChechbox(false);
                                      setSaveButtonLoading(false);
                                      openNotification(
                                        "success",
                                        "Setting updated successfully."
                                      );
                                    } else {
                                      setSaveButtonLoading(false);
                                      openNotification(
                                        "error",
                                        result.message ?? "There is some error."
                                      );
                                    }
                                  });
                                }
                              });
                            } else {
                              openNotification(
                                "error",
                                "Enter new template name."
                              );
                            }
                          }
                        }}
                      >
                      </Button>

                      <Button
                        icon={<CloseOutlined />}
                        onClick={() => {
                          setNote(undefined);
                          setIsEdit(false);
                        }}
                      >
                      </Button>
                    </Space>
                  ) : (
                    <Button
                      type="primary"
                      icon={<FormOutlined />}
                      onClick={() => {
                        setNote(undefined);

                        companySettings?.setting?.vouchersSettings.find(
                          (x) => x.title === select.label
                        );
                        setNotesInitial(
                          companySettings?.setting?.vouchersSettings?.find(
                            (x: any) => x.title === select.label
                          )?.settings?.invoiceSettings?.disclaimer
                        );
                        setIsEdit(true);
                      }}
                    >
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
          </Row> */}

          {/* <Divider className="my-7" /> */}

          {/* Search bar */}
          <div style={{ maxWidth: "708px", margin: "0 auto" }}>
            <Input
              placeholder="Search settings..."
              prefix={
                <SearchOutlined style={{ color: "#aaa", fontSize: "18px" }} />
              }
              allowClear
              style={{
                padding: "10px 16px",
                fontSize: "16px",
                marginBottom: "20px",
              }}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          {/* Properties of Voucher Template */}
          <div
            style={{
              height: "68vh",
              overflowY: "scroll",
              margin: "0 auto",
              maxWidth: "720px",
              overflowX: "hidden",
            }}
          >
            <Form
              form={form}
              colon={false}
              name="CustomizeSalesInvoice"
              requiredMark={true}
              labelCol={{ span: 7 }}
              labelAlign="left"
              initialValues={{
                start: "001",
                startNumberFrequency: 0,
                separator: "-",
                showItemDescription: true,
                defaultNature: Voucher_Nature.Regular,
                itemRateType: ItemRate_Type.Exclusive,
                discountPolicy: Discount_Policy.NoDiscount,
                autoRoundOff: true,
                roundOffType: RoundOff_Type.Normal,
                invoiceCopyLabelling: {
                  duplicateCopyType: DuplicateCopy_Type.Original,
                  title1: "Original",
                },
              }}
            >
              <>
                <div
                  style={{
                    padding: "15px",
                    position: "relative",
                  }}
                >
                  {/* --------- Sales Invoice --------- */}
                  <>
                    <div style={{ maxWidth: "700px", margin: "0 auto" }}>
                      {!props.templateName && !props.templateId && (
                        <Form.Item
                          name="voucherType"
                          className={`m-0 ${
                            shouldShowField("Voucher Type") ? "" : "hidden"
                          }`}
                          label={highlightLabel("Voucher Type")}
                          rules={[
                            {
                              required: true,
                              message: "Please select voucher type",
                            },
                          ]}
                        >
                          <Select
                            disabled={
                              props.templateName && props.templateId
                                ? true
                                : false
                            }
                            onSelect={(val: SettingsSections) =>
                              setSelTemplateType(val)
                            }
                            options={[
                              {
                                key: SettingsSections.Invoice,
                                value: SettingsSections.Invoice,
                                label: "Sales Invoice",
                              },
                              {
                                key: SettingsSections.PurInvoice,
                                value: SettingsSections.PurInvoice,
                                label: "Purchase Invoice",
                              },
                              {
                                key: SettingsSections.Quotation,
                                value: SettingsSections.Quotation,
                                label: "Estimate",
                              },
                              {
                                key: SettingsSections.SOrder,
                                value: SettingsSections.SOrder,
                                label: "Sales Order",
                              },
                              {
                                key: SettingsSections.POrder,
                                value: SettingsSections.POrder,
                                label: "Purchase Order",
                              },
                              {
                                key: SettingsSections.PInvoice,
                                value: SettingsSections.PInvoice,
                                label: "Proforma Invoice",
                              },
                              {
                                key: SettingsSections.Expenses,
                                value: SettingsSections.Expenses,
                                label: "Expense",
                              },
                              {
                                key: SettingsSections.Income,
                                value: SettingsSections.Income,
                                label: "Income",
                              },
                            ]}
                          ></Select>
                        </Form.Item>
                      )}
                      <Form.Item
                        name="title"
                        className={`m-0 ${
                          shouldShowField("Template Title") ? "" : "hidden"
                        }`}
                        label={highlightLabel("Template Title")}
                        rules={[
                          { required: true, message: "Title is required" },
                          {
                            validator(_, value: string) {
                              let findIndex =
                                companySettings?.setting?.vouchersSettings
                                  // ?.filter(
                                  //   (fVSet: vouchersSettings) =>
                                  //     fVSet.id !== props.templateId
                                  // )
                                  .findIndex(
                                    (vSet: vouchersSettings, index: number) =>
                                      vSet.title.toLowerCase() ===
                                      value.toLowerCase().trim()
                                  );
                              // && !props.templateId
                              if (findIndex! !== -1 && !props.templateId) {
                                return Promise.reject(
                                  "Voucher template name is already exists"
                                );
                              } else {
                                return Promise.resolve();
                              }
                            },
                          },
                        ]}
                      >
                        <Input className="custom-input small-font-input" />
                      </Form.Item>
                      <Divider orientation="left" orientationMargin={2}>
                        Basic Detail
                      </Divider>
                      <Form.Item
                        name="titleToBePrint"
                        className={`m-0 ${
                          shouldShowField("Title to be print") ? "" : "hidden"
                        }`}
                        label={highlightLabel("Title to be print")}
                      >
                        <Input className="custom-input small-font-input" />
                      </Form.Item>
                      <Form.Item
                        name="isSuffix"
                        className={`m-0 ${
                          shouldShowField("Prefix / Suffix") ? "" : "hidden"
                        }`}
                        label={highlightLabel("Prefix / Suffix")}
                      >
                        <Select
                          className="custom-select small-font-select"
                          placeholder="Select"
                          options={[
                            { value: false, label: "Prefix" },
                            { value: true, label: "Suffix" },
                          ]}
                        />
                      </Form.Item>
                      <Form.Item
                        name="preSuf"
                        className={`m-0 ${
                          shouldShowField("Prefix / Suffix Text")
                            ? ""
                            : "hidden"
                        }`}
                        label={highlightLabel("Prefix / Suffix Text")}
                        rules={[
                          {
                            min: 2,
                            max: 10,
                            message: "The maximum length is 10 characters only",
                          },
                        ]}
                      >
                        <Input
                          minLength={2}
                          maxLength={10}
                          className="custom-input small-font-input"
                        />
                      </Form.Item>
                      <Form.Item
                        name="start"
                        className={`m-0 ${
                          shouldShowField("Start from") ? "" : "hidden"
                        }`}
                        label={
                          <Tooltip title="Minimum text padding is 3 i.e. if you provide '1' it will be shown as '001' and if you provide '00001' then text padding will be automatic to 5">
                            {highlightLabel("Start from")}
                          </Tooltip>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input start number",
                          },
                        ]}
                      >
                        <Input
                          minLength={3}
                          maxLength={6}
                          className="custom-input small-font-input"
                          onBlur={(
                            e: React.FocusEvent<HTMLInputElement, Element>
                          ) => {
                            if (e.target?.value.length < 3) {
                              form.setFieldValue(
                                "start",
                                e?.target?.value.toString().padStart(3, "0")
                              );
                            }
                          }}
                          onKeyPress={(e) =>
                            !/[0-9]/.test(e.key) && e.preventDefault()
                          }
                        />
                      </Form.Item>
                      <Form.Item
                        name="yearInclude"
                        label={highlightLabel("Year Include")}
                        valuePropName="checked"
                        className={`m-0 ${
                          shouldShowField("Year Include") ? "" : "hidden"
                        }`}
                      >
                        <Checkbox
                          style={{ marginTop: "6px", width: "40px" }}
                        ></Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="monthInclude"
                        label={highlightLabel("Month Include")}
                        valuePropName="checked"
                        className={`m-0 ${
                          shouldShowField("Month Include") ? "" : "hidden"
                        }`}
                      >
                        <Checkbox style={{ marginTop: "6px" }} />
                      </Form.Item>
                      <Form.Item
                        name="monthNumFormat"
                        label={highlightLabel("Month Format")}
                        className={`m-0 ${
                          shouldShowField("Month Format") ? "" : "hidden"
                        }`}
                      >
                        <Select
                          className="custom-select small-font-select"
                          placeholder="Select format"
                          options={[
                            { value: 0, label: "Number" },
                            { value: 1, label: "Text" },
                          ]}
                        />
                      </Form.Item>
                      <Form.Item
                        name="startNumberFrequency"
                        label={highlightLabel("Frequency of No.")}
                        className={`m-0 ${
                          shouldShowField("Frequency of No.") ? "" : "hidden"
                        }`}
                        rules={[
                          {
                            required: true,
                            message: "Please number frequency",
                          },
                        ]}
                      >
                        <Select
                          className="custom-select small-font-select"
                          placeholder="Select frequency"
                          options={[
                            { value: 0, label: "Yearly" },
                            { value: 1, label: "Monthly" },
                          ]}
                        />
                      </Form.Item>
                      <Form.Item
                        label={highlightLabel("Separator")}
                        name="separator"
                        className={`m-0 ${
                          shouldShowField("Separator") ? "" : "hidden"
                        }`}
                      >
                        <Select
                          className="custom-select small-font-select"
                          placeholder="Separator"
                          options={[
                            { value: "-", label: "-" },
                            { value: "#", label: "#" },
                            { value: "/", label: "/" },
                          ]}
                        />
                      </Form.Item>
                      {/* <Form.Item
                        label={highlightLabel("Disclaimer")}
                        name="disclaimer"
                        className={`m-0 ${
                          shouldShowField("Disclaimer") ? "" : "hidden"
                        }`}
                      >
                        <div
                          style={{
                            background: "rgba(0, 0, 0, 0.04)",
                            padding: 10,
                            height: "130px",
                            border: "1px solid #d9d9d9",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: fromData?.allFiled?.disclaimer!,
                          }}
                        />
                      </Form.Item> */}
                      <Divider orientation="left" orientationMargin={2}>
                        Other Detail
                      </Divider>

                      <Form.Item
                        className={`m-2 ${
                          shouldShowField("Disclaimer") ? "" : "hidden"
                        }`}
                        label={highlightLabel("Disclaimer")}
                        name="disclaimer"
                      >
                        <SunEditor
                          setContents={disclaimerText}
                          setOptions={{
                            buttonList: [
                              ["undo", "redo"],
                              ["font", "fontSize"],
                              ["bold", "underline", "italic", "strike"],
                              ["fontColor", "hiliteColor"],
                              ["align", "list", "lineHeight"],
                              ["outdent", "indent"],
                              ["removeFormat"],
                            ],
                            defaultTag: "div",
                            showPathLabel: false,
                          }}
                          height="150px"
                          // onChange={handleChange}
                        />
                      </Form.Item>
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.PInvoice ||
                        selTemplateType === SettingsSections.CrNote ||
                        selTemplateType === SettingsSections.DrNote ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.POrder) && (
                        <>
                          <Form.Item
                            label={highlightLabel("Terms & Conditions")}
                            className={`m-2 ${
                              shouldShowField("Terms & Conditions")
                                ? ""
                                : "hidden"
                            }`}
                          >
                            <Button
                              size="small"
                              style={{
                                backgroundColor: "ButtonFace",
                                marginTop: "5px",
                              }}
                              onClick={() => {
                                setOpenModel({
                                  type: "termsAndConditionsModal",
                                  param: { open: true },
                                });
                              }}
                            >
                              Select Terms & Conditions
                            </Button>
                          </Form.Item>
                          <Form.Item
                            className={`m-2 ${
                              shouldShowField("Terms & Conditions")
                                ? ""
                                : "hidden"
                            }`}
                            label={highlightLabel("Terms & Conditions")}
                            name="termsnConditions"
                          >
                            <SunEditor
                              setContents={tnCText}
                              setOptions={{
                                buttonList: [
                                  ["undo", "redo"],
                                  ["font", "fontSize"],
                                  ["bold", "underline", "italic", "strike"],
                                  ["fontColor", "hiliteColor"],
                                  ["align", "list", "lineHeight"],
                                  ["outdent", "indent"],
                                  ["removeFormat"],
                                ],
                                defaultTag: "div",
                                showPathLabel: false,
                              }}
                              height="150px"
                              // onChange={handleChange}
                            />
                          </Form.Item>

                          {/* <Form.Item
                            label={highlightLabel("Terms & Conditions")}
                            name="termsnConditions"
                            className={`m-2 ${
                              shouldShowField("Terms & Conditions")
                                ? ""
                                : "hidden"
                            }`}
                          >
                            <div
                              style={{
                                background: "rgba(0, 0, 0, 0.04)",
                                padding: 10,
                                height: "130px",
                                overflowX: "scroll",
                                border: "1px solid #d9d9d9",
                              }}
                            />
                          </Form.Item> */}
                        </>
                      )}
                      {selTemplateType === SettingsSections.Invoice && (
                        <Form.Item
                          label={highlightLabel("Show Contact Detail")}
                          name="showContactDetail"
                          className={`m-0 ${
                            shouldShowField("Show Contact Detail")
                              ? ""
                              : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox></Checkbox>
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.Expenses ||
                        selTemplateType === SettingsSections.Income) && (
                        <Form.Item
                          label={highlightLabel(
                            selTemplateType === SettingsSections.Invoice
                              ? "Show Receipt"
                              : "Show Payment"
                          )}
                          name="showReceipt"
                          className={`m-0 ${
                            shouldShowField(
                              selTemplateType === SettingsSections.Invoice
                                ? "Show Receipt"
                                : "Show Payment"
                            )
                              ? ""
                              : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox style={{ marginTop: "5px" }} />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.CrNote ||
                        selTemplateType === SettingsSections.DrNote ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.POrder ||
                        selTemplateType === SettingsSections.PInvoice) && (
                        <Form.Item
                          label={highlightLabel("Show Shipping Address")}
                          name="showShippingAddress"
                          className={`m-0 ${
                            shouldShowField("Show Shipping Address")
                              ? ""
                              : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.POrder) && (
                        <Form.Item
                          label={highlightLabel("Show Price History")}
                          name="showPriceHistory"
                          className={`m-0 ${
                            shouldShowField("Show Price History")
                              ? ""
                              : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox style={{ marginTop: "5px" }} />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.CrNote ||
                        selTemplateType === SettingsSections.DrNote ||
                        selTemplateType === SettingsSections.POrder ||
                        selTemplateType === SettingsSections.PInvoice) && (
                        <Form.Item
                          label={highlightLabel("Show Other Charges")}
                          name="showOtherCharges"
                          className={`m-0 ${
                            shouldShowField("Show Other Charges")
                              ? ""
                              : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.Expenses ||
                        selTemplateType === SettingsSections.Income) && (
                        <Form.Item
                          label={highlightLabel("E-Invoicing")}
                          name="eInvoicing"
                          className={`m-0 ${
                            shouldShowField("E-Invoicing") ? "" : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox style={{ marginTop: "5px" }} />
                        </Form.Item>
                      )}
                      {selTemplateType === SettingsSections.Invoice && (
                        <Form.Item
                          label={highlightLabel("E-Way billing")}
                          name="eWayBilling"
                          className={`m-0 ${
                            shouldShowField("E-Way billing") ? "" : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.PInvoice ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.POrder ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.Expenses ||
                        selTemplateType === SettingsSections.Income ||
                        selTemplateType === SettingsSections.CrNote ||
                        selTemplateType === SettingsSections.DrNote) && (
                        <Form.Item
                          label={highlightLabel("Show Item Description")}
                          name="showItemDescription"
                          className={`m-0 ${
                            shouldShowField("Show Item Description")
                              ? ""
                              : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.CrNote ||
                        (selTemplateType as SettingsSections) ===
                          SettingsSections.DrNote) && (
                        <Form.Item
                          label={`${
                            selTemplateType === SettingsSections.CrNote
                              ? highlightLabel("Credit")
                              : highlightLabel("Debit")
                          } Note day limit`}
                          name="returnNoteDayLimit"
                          className={`m-0 ${
                            shouldShowField(
                              selTemplateType === SettingsSections.Invoice
                                ? "Credit"
                                : "Debit"
                            )
                              ? ""
                              : "hidden"
                          }`}
                        >
                          <InputNumber min={0} controls={false} />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice) && (
                        <Form.Item
                          label={
                            selTemplateType === SettingsSections.Invoice
                              ? "Show Despatch Details"
                              : "Show Receipt Note"
                          }
                          name="showDispatchDetail"
                          className={`m-0 ${
                            shouldShowField(
                              selTemplateType === SettingsSections.Invoice
                                ? "Show Despatch Details"
                                : "Show Receipt Note"
                            )
                              ? ""
                              : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice) && (
                        <Form.Item
                          label={
                            selTemplateType === SettingsSections.Invoice
                              ? "Show Export Detail"
                              : "Show Import Detail"
                          }
                          name="showExportDetail"
                          className={`m-0 ${
                            shouldShowField(
                              selTemplateType === SettingsSections.Invoice
                                ? "Show Export Detail"
                                : "Show Import Detail"
                            )
                              ? ""
                              : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.POrder ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.PInvoice) && (
                        <Form.Item
                          label={highlightLabel("Show Freight Type")}
                          name="showFreightType"
                          className={`m-0 ${
                            shouldShowField("Show Freight Type") ? "" : "hidden"
                          }`}
                          valuePropName="checked"
                        >
                          <Checkbox />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.Expenses ||
                        selTemplateType === SettingsSections.Income ||
                        selTemplateType === SettingsSections.POrder ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.PInvoice) &&
                        currentClient?.gstType === CompanyGSTTypes.Regular && (
                          <Form.Item
                            label={highlightLabel("Show Reverse Charge (RCM)")}
                            name="showRCM"
                            className={`m-0 ${
                              shouldShowField("Show Reverse Charge (RCM)")
                                ? ""
                                : "hidden"
                            }`}
                            valuePropName="checked"
                          >
                            <Checkbox
                              onChange={(e) => {
                                setShowRCM(e.target.checked);
                              }}
                            />
                          </Form.Item>
                        )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PInvoice ||
                        selTemplateType === SettingsSections.Expenses ||
                        selTemplateType === SettingsSections.Income ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.POrder) && (
                        <Form.Item
                          label={highlightLabel("Default Nature")}
                          name="defaultNature"
                          className={`m-0 ${
                            shouldShowField("Default Nature") ? "" : "hidden"
                          }`}
                          // initialValue={Voucher_Nature.Regular}
                        >
                          <Select
                            options={
                              showRCM
                                ? voucherNatureOptions
                                : voucherNatureOptions.filter(
                                    (vNature: any) =>
                                      vNature.value !== Voucher_Nature.RCM
                                  )
                            }
                          />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PInvoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.POrder) && (
                        <Form.Item
                          label={highlightLabel("Item rate type")}
                          name="itemRateType"
                          className={`m-0 ${
                            shouldShowField("Item rate type") ? "" : "hidden"
                          }`}
                          // initialValue={ItemRate_Type.Exclusive}
                        >
                          <Select
                            options={[
                              {
                                value: ItemRate_Type.Exclusive,
                                label: "Exclusive",
                              },
                              {
                                value: ItemRate_Type.Inclusive,
                                label: "Inclusive",
                              },
                            ]}
                          />
                        </Form.Item>
                      )}

                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.POrder ||
                        selTemplateType === SettingsSections.PInvoice) && (
                        <Form.Item
                          label={highlightLabel("Discount policy")}
                          name="discountPolicy"
                          className={`m-0 ${
                            shouldShowField("Discount policy") ? "" : "hidden"
                          }`}
                          // initialValue={Discount_Policy.NoDiscount}
                        >
                          <Select
                            options={[
                              {
                                value: Discount_Policy.NoDiscount,
                                label: "No Discount",
                              },
                              {
                                value: Discount_Policy.OnlyTradeDiscount,
                                label: "Only trade discount",
                              },
                              ...(selTemplateType ===
                                SettingsSections.Invoice ||
                              selTemplateType === SettingsSections.PurInvoice
                                ? [
                                    {
                                      value: Discount_Policy.OnlyCashDiscount,
                                      label: "Only cash discount",
                                    },
                                  ]
                                : []),
                              ...(selTemplateType ===
                                SettingsSections.Invoice ||
                              selTemplateType === SettingsSections.PurInvoice
                                ? [
                                    {
                                      value: Discount_Policy.TradenCashDiscount,
                                      label: "Trade & cash discount",
                                    },
                                  ]
                                : []),
                            ]}
                          />
                        </Form.Item>
                      )}
                      {(selTemplateType === SettingsSections.Invoice ||
                        selTemplateType === SettingsSections.PurInvoice ||
                        selTemplateType === SettingsSections.CrNote ||
                        selTemplateType === SettingsSections.DrNote ||
                        selTemplateType === SettingsSections.Payment ||
                        selTemplateType === SettingsSections.Receipt ||
                        selTemplateType === SettingsSections.Quotation ||
                        selTemplateType === SettingsSections.POrder ||
                        selTemplateType === SettingsSections.SOrder ||
                        selTemplateType === SettingsSections.Expenses ||
                        selTemplateType === SettingsSections.Income ||
                        selTemplateType === SettingsSections.PInvoice) && (
                        <>
                          <Form.Item
                            label={highlightLabel("Round off to nearest 1")}
                            name="autoRoundOff"
                            className={`m-0 ${
                              shouldShowField("Round off to nearest 1")
                                ? ""
                                : "hidden"
                            }`}
                            valuePropName="checked"
                          >
                            <Checkbox />
                          </Form.Item>
                          <Form.Item
                            label={highlightLabel("RoundOff Type")}
                            name="roundOffType"
                            className={`m-0 ${
                              shouldShowField("RoundOff Type") ? "" : "hidden"
                            }`}
                            // initialValue={RoundOff_Type.Normal}
                          >
                            <Select
                              style={{ width: "100%" }}
                              options={[
                                {
                                  value: RoundOff_Type.Normal,
                                  label: "Normal",
                                },
                                {
                                  value: RoundOff_Type.Ceiling,
                                  label: "Ceiling",
                                },
                                {
                                  value: RoundOff_Type.Floor,
                                  label: "Floor",
                                },
                              ]}
                            />
                          </Form.Item>
                        </>
                      )}
                      {selTemplateType === SettingsSections.Invoice && (
                        <>
                          <Form.Item
                            label={highlightLabel("Invoice copy labelling")}
                            name={["invoiceCopyLabelling", "duplicateCopyType"]}
                            // initialValue={DuplicateCopy_Type.Original}
                            className={`m-0 ${
                              shouldShowField("Invoice copy labelling")
                                ? ""
                                : "hidden"
                            }`}
                          >
                            <Select
                              onChange={(val: DuplicateCopy_Type) =>
                                setDuplicateCopy(val)
                              }
                              options={[
                                {
                                  value: DuplicateCopy_Type.Original,
                                  label: "Original",
                                },
                                {
                                  value: DuplicateCopy_Type.Duplicate,
                                  label: "Duplicate",
                                },
                                {
                                  value: DuplicateCopy_Type.Triplicate,
                                  label: "Triplicate",
                                },
                                {
                                  value: DuplicateCopy_Type.Quadruplicate,
                                  label: "Quadruplicate",
                                },
                                {
                                  value: DuplicateCopy_Type.Quintuplicate,
                                  label: "Quintuplicate",
                                },
                              ]}
                            />
                          </Form.Item>

                          {duplicateCopy === DuplicateCopy_Type.Original ||
                          duplicateCopy === DuplicateCopy_Type.Duplicate ||
                          duplicateCopy === DuplicateCopy_Type.Triplicate ||
                          duplicateCopy === DuplicateCopy_Type.Quadruplicate ||
                          duplicateCopy === DuplicateCopy_Type.Quintuplicate ? (
                            <Form.Item
                              label={highlightLabel("Copy-1")}
                              name={["invoiceCopyLabelling", "title1"]}
                              className={`m-0 ${
                                shouldShowField("Copy-1") ? "" : "hidden"
                              }`}
                            >
                              <Input />
                            </Form.Item>
                          ) : (
                            <></>
                          )}
                          {duplicateCopy === DuplicateCopy_Type.Duplicate ||
                          duplicateCopy === DuplicateCopy_Type.Triplicate ||
                          duplicateCopy === DuplicateCopy_Type.Quadruplicate ||
                          duplicateCopy === DuplicateCopy_Type.Quintuplicate ? (
                            <Form.Item
                              label={highlightLabel("Copy-2")}
                              name={["invoiceCopyLabelling", "title2"]}
                              className={`m-0 ${
                                shouldShowField("Copy-2") ? "" : "hidden"
                              }`}
                            >
                              <Input />
                            </Form.Item>
                          ) : (
                            ""
                          )}
                          {duplicateCopy === DuplicateCopy_Type.Triplicate ||
                          duplicateCopy === DuplicateCopy_Type.Quadruplicate ||
                          duplicateCopy === DuplicateCopy_Type.Quintuplicate ? (
                            <Form.Item
                              label={highlightLabel("Copy-3")}
                              name={["invoiceCopyLabelling", "title3"]}
                              className={`m-0 ${
                                shouldShowField("Copy-3") ? "" : "hidden"
                              }`}
                            >
                              <Input />
                            </Form.Item>
                          ) : (
                            ""
                          )}
                          {duplicateCopy === DuplicateCopy_Type.Quadruplicate ||
                          duplicateCopy === DuplicateCopy_Type.Quintuplicate ? (
                            <Form.Item
                              label={highlightLabel("Copy-4")}
                              name={["invoiceCopyLabelling", "title4"]}
                              className={`m-0 ${
                                shouldShowField("Copy-4") ? "" : "hidden"
                              }`}
                            >
                              <Input />
                            </Form.Item>
                          ) : (
                            ""
                          )}
                          {duplicateCopy ===
                          DuplicateCopy_Type.Quintuplicate ? (
                            <Form.Item
                              label={highlightLabel("Copy-5")}
                              name={["invoiceCopyLabelling", "title5"]}
                              className={`m-0 ${
                                shouldShowField("Copy-5") ? "" : "hidden"
                              }`}
                            >
                              <Input />
                            </Form.Item>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                      <Row
                        justify={"end"}
                        style={{
                          marginTop: "20px",
                          bottom: 0,
                        }}
                      ></Row>
                    </div>
                  </>
                </div>
              </>
            </Form>
          </div>
        </div>
      </Drawer>

      {openModel.type === "termsAndConditionsModal" && (
        <TermsAndConditionModal
          open={openModel.param.open}
          onCancel={() => setOpenModel({ type: "", param: { open: false } })}
          setTermsAndConditionField={setTnCTemplateID}
          termsAndConditionField={tnCTemplateID}
          voucherType={
            selTemplateType === SettingsSections.Invoice
              ? Voucher_Type?.SalesVoucher
              : selTemplateType === SettingsSections.CrNote
              ? Voucher_Type?.CreditNote
              : selTemplateType === SettingsSections.DrNote
              ? Voucher_Type?.DebitNote
              : selTemplateType === SettingsSections.PurInvoice
              ? Voucher_Type?.PurchaseVoucher
              : selTemplateType === SettingsSections.Quotation
              ? Voucher_Type?.SalesVoucher
              : selTemplateType === SettingsSections.POrder
              ? Voucher_Type?.PurchaseVoucher
              : selTemplateType === SettingsSections.SOrder
              ? Voucher_Type?.SalesVoucher
              : ""
          }
          voucherTitleCustomization={props.templateId!}
        />
      )}
      {openNotes && (
        <AdditionalNotes
          value={note ? note : notesInitial ? notesInitial : ""}
          open={openNotes}
          save={(a: string) => {
            setOpenNotes(false);
            setNote(a);
          }}
          cancel={() => setOpenNotes(false)}
        />
      )}
    </>
  );
};

export default SettingVoucherTemplate;
